const toString = Object.prototype.toString

/**
 * 深度拷贝
 * @param source 源对象
 * @param cache 标记已复制对象，防止循环引用
 * @returns
 */
export default function cloneDeep(source: any, cache = new WeakMap()): any {
  if (typeof source !== 'object' || source === null) {
    return source
  }

  const resCache = cache.get(source)
  if (resCache) {
    return resCache
  }
  const dataType = toString.call(source).slice(8, -1).toLowerCase()
  const ctor = source.constructor
  let res: any = null
  switch (dataType) {
    case 'number':
    case 'string':
      res = new ctor(source)
      break
    case 'boolean':
    case 'date':
      res = new ctor(source - 0)
      break
    case 'regexp':
      res = new ctor(source.source, source.flags)
      break
    case 'set':
    case 'map':
    case 'array':
    case 'object':
      try {
        res = new ctor()
      } catch (_) {
        res = source
      }
      break
    default:
      res = source
  }
  if (dataType === 'set') {
    source.forEach((x: any) => {
      res.add(cloneDeep(x, cache))
    })
  } else if (dataType === 'map') {
    Array.from(source.entries()).forEach((k, v) => {
      res.set(k, cloneDeep(v, cache))
    })
  } else if (dataType === 'array' || dataType === 'object') {
    // const oKeys = Object.getOwnPropertyNames(source).concat(Object.getOwnPropertySymbols(source));
    const oKeys = Reflect.ownKeys(source)
    for (const k of oKeys) {
      res[k] = cloneDeep(source[k], cache)
    }
  }
  cache.set(source, res)
  return res
}
